import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, reset } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import { notification } from 'antd';
import get from 'lodash/get';
import { withRouter } from 'react-router';
import CampaignsAdd from '../../components/molecules/CampaignsAdd/index';
import { isOpen } from '../../store/modal/selectors';
import { modalHide } from '../../store/modal/actions';
import { createValidator, required } from '../../services/validation/index';
import { emptyEditRecord } from '../../store/updateCampaign/actions';
import { fromEntities, fromResource } from '../../store/selectors';
import { resourceListReadRequest } from '../../store/resource/actions';

class CampaignsAddContainer extends Component {
  componentDidMount() {
    Promise.all([
      this.props.getAdminList(),
      this.props.getAdvertiserList(),
      this.props.getPublisherList(),
    ]).catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not retrieve backend data',
        duration: 0,
      });
    });
  }

  advertiserOptions = () =>
    this.props.advertiserList.map(a => ({
      title: a.name,
      label: a.name,
      value: a.uuid,
    }));

  publisherOptions = () =>
    this.props.publisherList.map(a => ({
      title: a.name,
      label: a.name,
      value: a.uuid,
    }));

  userOptions = () =>
    this.props.adminList.map(a => ({
      title: `${a.first_name} ${a.last_name} ${a.email}`,
      label: `${a.first_name} ${a.last_name} ${a.email}`,
      value: a.id,
    }));

  render() {
    return (
      <CampaignsAdd
        adminOptions={this.userOptions()}
        publisherOptions={this.publisherOptions()}
        advertiserOptions={this.advertiserOptions()}
        {...this.props}
      />
    );
  }
}

const onSubmit = (values, dispatch, props) => {
  const requestData = values;
  const newAdvertiser = !props.advertiserList.find(a => a.uuid === requestData.advertiser_uuid);
  if (newAdvertiser) {
    requestData.advertiser_name = values.advertiser_uuid;
    delete requestData.advertiser_uuid;
  }

  if (values.rangepicker && values.rangepicker[0] && values.rangepicker[1]) {
    requestData.start_date = values.rangepicker[0];
    requestData.end_date = values.rangepicker[1];

    delete requestData.rangepicker;
  }

  if (props.isEdit) {
    return props
      .handleUpdateCampaign(requestData)
      .then(() => {
        props.onCancel();
        dispatch(reset('CampaignsAdd'));
        notification.success({ message: 'Success', description: 'Campaign updated.', duration: 4 });
      })
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not update campaign.',
          duration: 0,
        })
      );
  }
  return props
    .handleCreateCampaign(requestData)
    .then(id => {
      props.onCancel();
      dispatch(reset('CampaignsAdd'));
      notification.success({ message: 'Success', description: 'Campaign created.', duration: 4 });
      props.history.push(`/campaigns/${id}`);
    })
    .catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not create campaign.',
        duration: 0,
      });
    });
};

const validate = createValidator({
  name: [required],
  actor_id: [required],
  start_date: [required],
  end_date: [required],
  seller_pub_uuid: [required],
  advertiser_uuid: [required],
});

const mapStateToProps = ({ modal, updateCampaign, auth, ...state }) => ({
  visible: isOpen(modal, 'add-campaign'),
  adminName: get(auth, 'user.username', false),
  advertiserList: fromEntities.getList(
    state,
    'advertiser',
    fromResource.getList(state, 'advertiser')
  ),
  publisherList:
    fromEntities.getList(state, 'publisher', fromResource.getList(state, 'publisher')) || [],
  adminList: fromEntities.getList(state, 'userAdmin', fromResource.getList(state, 'userAdmin')),
  isEdit: !isEmpty(updateCampaign),
  initialValues: {
    seller_pub_uuid: '00EF4590-8F46-42F1-B69C-EDC954FFAD4B', // "inMarket"
    actor_id: `${get(auth, 'user.admin_id', false)}`,
    ...updateCampaign,
  },
});

const mapDispatchToProps = dispatch => ({
  getAdminList: () =>
    dispatch(resourceListReadRequest('user/admin', { sort_by: 'first_name', page_size: 50000 })),
  getAdvertiserList: () =>
    dispatch(resourceListReadRequest('advertiser', { sort_by: 'name', page_size: 50000 })),
  getPublisherList: () =>
    dispatch(resourceListReadRequest('publisher', { sort_by: 'name', page_size: 50000 })),
  onCancel: () => {
    dispatch(modalHide('add-campaign'));

    // Timeout because hiding is a slow fade.
    // We don't want to flash the form resetting
    setTimeout(() => dispatch(emptyEditRecord()), 100);
  },
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    enableReinitialize: true,
    destroyOnUnmount: false,
    form: 'CampaignsAdd',
    onSubmit,
    validate,
  })
)(CampaignsAddContainer);
